import { Component } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';

@Component({
  selector: 'sura-contact-the-registry',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './contact-the-registry.component.html',
  styleUrl: './contact-the-registry.component.scss',
})

export class ContactTheRegistryComponent { 
  redirect() {
    window.location.href = 'https://www.sura.co/';
  }
}
